﻿import { useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Row, Col, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import Head from "@/components/Content/Head";
import BasePagination from "@/components/Pagination/BasePagination";
import Fetching from "@/components/Fetching/Fetching";
import BasicConfirm from "@/components/Confirm/BasicConfirm";
import classes from "../../maintainers.module.scss";

import { useIrrigationPaginate, useMutateIrrigation, useMutateDeleteIrrigation } from "@/hooks/maintainers/application_orders";
import { base_list } from "./irrigations.constants";
import { hasPermission } from "@/services/Utils";
import IrrigationsTableBody from "./IrrigationsTableBody";
import IrrigationsTableHead from "./IrrigationsTableHead";
import IrrigationsForm from "./IrrigationsForm/IrrigationsForm";

const Irrigations = () => {
	const { addToast } = useToasts();
	const { search, estate_id } = useSelector((state) => state.auth.filter);
	const { option } = useParams();
	const navigate = useNavigate();

	const [base, setBase] = useState({ ...base_list });
	const [showDelete, setShowDelete] = useState(false);
	const [selected, setSelected] = useState("");

	const { data, isLoading, isFetching } = useIrrigationPaginate({
		...base,
		search,
		estate_id,
	});
	const { mutate: mutateSave, isLoading: isLoadingSave } = useMutateIrrigation({
		...base,
		search,
		estate_id,
	});
	const { mutate: mutateDelete, isLoading: isLoadingDelete } = useMutateDeleteIrrigation({
		...base,
		search,
		estate_id,
	});

	const { irrigations: list, permissions, estates_parents, estates, business_centers } = data ? data : {};
	const { data: irrigations, last_page, total, from, to } = list ? list : {};

	const handleDelete = (item) => {
		setSelected(item.id);
		setShowDelete(true);
	};

	const confirmDelete = () => {
		mutateDelete(
			{ ...base, search, estate_id, selected },
			{
				onSuccess: () => {
					setSelected("");
					setShowDelete(false);
					addToast("Sector de Riego eliminado correctamente.", {
						appearance: "success",
					});
				},
			},
		);
	};

	const confirmSave = (data) => {
		mutateSave(
			{ ...base, search, estate_id, params: { ...data } },
			{
				onSuccess: () => {
					addToast("Sector de Riego guardado correctamente.", {
						appearance: "success",
					});
				},
			},
		);
	};

	const setPage = (value) => setBase({ ...base, page: value });
	const setOrder = (value) => setBase({ ...base, order: value });
	const setOrderType = (value) => setBase({ ...base, orderType: value });
	const setPaginate = (value) => setBase({ ...base, paginate: value });

	if (isLoading || isLoadingDelete) {
		return <Fetching />;
	}

	return (
		<>
			<Head
				title="Sectores de Riego"
				button={true}
				button_text={"Sector de Riego"}
				action={() => navigate("/configuracion/riegos/crear")}
				back_url={"/configuracion?section=orderApplication"}
				isFetching={isFetching}
			/>

			{hasPermission("show", permissions) && (
				<Row className={` ${classes.main_row}`}>
					<Col md={12} className={classes.main_col}>
						<Row className={classes.table}>
							<div className={classes.table_div}>
								<Table className={classes.table_desktop}>
									<IrrigationsTableHead order={base.order} setOrder={setOrder} orderType={base.orderType} setOrderType={setOrderType} />

									<IrrigationsTableBody data={irrigations} handleDelete={handleDelete} permissions={permissions} base={base} />
								</Table>
							</div>
						</Row>

						<BasePagination
							page={base.page}
							paginate={base.paginate}
							last_page={last_page}
							quantity={total}
							from={from}
							to={to}
							setPage={setPage}
							setPaginate={setPaginate}
						/>
					</Col>
				</Row>
			)}

			<BasicConfirm
				showConfirm={showDelete}
				setShowConfirm={setShowDelete}
				handleAction={confirmDelete}
				showValidation={true}
				textValidation={"eliminar sector de riego"}
			/>

			{option && (
				<IrrigationsForm
					confirmSave={confirmSave}
					isLoadingSave={isLoadingSave}
					permissions={permissions}
					base={base}
					estates_parents={estates_parents}
					estates={estates}
					business_center={business_centers}
				/>
			)}
		</>
	);
};

export default Irrigations;
